import { LazyImg } from "./LazyImg";

interface LazyImgWithFallbackProps {
  src: string;
  fallback: string;
  type?: string;
  alt?: string;
  width?: string;
  height?: string;
  style?: React.CSSProperties;
  className?: string;
}

export function LazyImgWithFallback({
  src,
  fallback,
  type = "image/webp",
  alt,
  width,
  height,
  style,
  className = "",
}: LazyImgWithFallbackProps) {
  return (
    <picture>
      <source
        key={src}
        srcSet={src}
        type={type}
        className={className}
        style={style}
      />
      <LazyImg
        src={fallback}
        className={className}
        style={style}
        alt={alt}
        width={width}
        height={height}
      />
    </picture>
  );
}
